import React from "react";
import { Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import "./InputGroup.css";
import classNames from "classnames";

export const InputGroup = ({
  label,
  alignment,
  type,
  variant,
  children,
  tooltip,
  note,
}: {
  label: string,
  alignment?: string,
  type?: string,
  variant?: string,
  children: any,
  tooltip?: string,
  note?: string,
}) => {
  var inputGroupClass = classNames("input-group", {
    [`input-group--${alignment}`]: alignment,
    [`input-group--${type}`]: type,
    [`input-group--${variant}`]: variant,
  });

  return (
    <div className={inputGroupClass}>
      <label className="input-group__label">
        {label}{" "}
        {tooltip && (
          <Tooltip placement="topLeft" arrowPointAtCenter title={tooltip}>
            <QuestionCircleOutlined className="icon icon--interactive" />
          </Tooltip>
        )}
      </label>
      {note && <div className="input-group__note">{note}</div>}
      <div className="input-group__input">{children}</div>
    </div>
  );
};
